import React, { useEffect, useState } from 'react';
import './checkInput.css';
import Link from '../link/Link';
const CheckInput = ({
	children,
	value,
	error,
	success,
	checked,
	onChange = () => {},
	disabled,
	link,
	linkClick,
	name,
	url
}) => {
	const [isChecked, setIsChecked] = useState(checked);

	useEffect(() => setIsChecked(checked), [checked]);

	const onClick = (e) => {
		onChange(e);
		setIsChecked(!isChecked);
	};

	return (
		<label
			className={`com-checkbox ${(error && 'state--error') || ''} ${
				(success && 'state--success') || ''
			} ${(disabled && 'state--disabled') || ''}`}
		>
			<input
				type="checkbox"
				value={value}
				disabled={disabled}
				onChange={onClick}
				checked={isChecked}
				name={name}
			/>
			<span>
				{children} {link && <Link target="_blank" href={url} onClick={linkClick} children={link} />}
			</span>
		</label>
	);
};

export default CheckInput;
